<template>
  <div>
    <template v-if="viewAction">
      <b-dropdown
        split
        text="Görüntüle"
        variant="outline-primary"
        right
        size="sm"
        @click="$router.push(viewAction)"
      >
        <template #button-content>
          <feather-icon
            icon="EyeIcon"
          />
          Görüntüle
        </template>
        <b-dropdown-item
          @click="$router.push(editAction)"
        >
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">Güncelle</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="archiveAction && dataId"
          @click="archiveAction(dataId)"
        >
          <feather-icon icon="ArchiveIcon" />
          <span class="align-middle ml-50">Arşivle</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="deleteAction && dataId"
          @click="deleteAction(dataId)"
        >
          <feather-icon icon="XIcon" />
          <span class="align-middle ml-50">Sil</span>
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template v-else-if="deleteAction && dataId">
      <b-dropdown
        split
        text="Güncelle"
        variant="outline-primary"
        right
        size="sm"
        @click="$router.push(editAction)"
      >
        <template #button-content>
          <feather-icon
            icon="EditIcon"
          />
          Güncelle
        </template>
        <b-dropdown-item
          v-if="deleteAction && dataId"
          @click="deleteAction(dataId)"
        >
          <feather-icon icon="XIcon" />
          <span class="align-middle ml-50">Sil</span>
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template v-else>
      <b-button
        :to="editAction"
        variant="outline-primary"
        size="sm"
      >
        <feather-icon
          icon="EditIcon"
        />
        Güncelle
      </b-button>
    </template>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BButton } from 'bootstrap-vue'

export default {
  name: 'ListButtons',
  components: {
    BDropdown, BDropdownItem, BButton,
  },
  props: {
    viewAction: {
      type: String,
      default: null,
    },
    editAction: {
      type: String,
      required: true,
    },
    dataId: {
      type: String,
      required: false,
      default: null,
    },
    deleteAction: {
      type: Function,
      required: false,
      default: null,
    },
    archiveAction: {
      type: Function,
      required: false,
      default: null,
    },
  },
}
</script>

<style scoped>

</style>
